import { Injectable } from '@angular/core';
import { ShareData } from '../models/share-modal.models';

@Injectable({
	providedIn: 'root',
})
export class ShareModalService {
	shareData!: ShareData;
	universityUrl!: string;

	setShareData(shareData: ShareData) {
		this.shareData = shareData;
	}

	createShareLink(platform: string) {
		const review = this.shareData.review;
		if (review !== null) {
			const uniLink = this.shareData.universityUrl;
			const uniName = this.shareData.universityName;
			const name = review.username;
			const rating = review.rating;
			const linkToReview = `https://universitycompare.com/universities/${uniLink}/reviews/?reviewId=${review.id}`;

			let linkText = '';

			if (platform === 'twitter') {
				const uniCompareHandle = '@uni_compare';
				const text = `${name} gave ${uniName} ${rating} stars via ${uniCompareHandle}: `;
				const urlEncodedText = encodeURI(text);
				linkText = `https://twitter.com/intent/tweet?text=${urlEncodedText}&url=${linkToReview}`;
			} else if (platform === 'facebook') {
				const text = `${name} gave ${uniName} ${rating} stars via Uni Compare: `;
				const urlEncodedText = encodeURI(text);
				linkText = `https://www.facebook.com/share.php?u=${linkToReview}&quote=${urlEncodedText}`;
			}
			return linkText;
		}
		return '';
	}
}
